import { useSettingsStore } from '../store'
import { HourConfigField } from './HourConfigField'

export function GeneralHoursTab() {
  const { hourSettings, updateGeneralHours, updateRecipesRulesHours } = useSettingsStore()
  const general = hourSettings.general
  const recipesRules = hourSettings.recipesRules

  return (
    <div className="space-y-6">
      {/* General Setup */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Project Setup</h4>
        <HourConfigField
          label="Project Setup"
          value={general.projectSetup}
          onChange={(v) => updateGeneralHours('projectSetup', v)}
          description="Initial project configuration"
        />
        <HourConfigField
          label="Parent/Child Configuration"
          value={general.parentChildConfig}
          onChange={(v) => updateGeneralHours('parentChildConfig', v)}
          description="Entity hierarchy setup"
        />
      </div>

      {/* Recipes & Rules */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Recipes & Rules</h4>
        <HourConfigField
          label="Per Recipe"
          value={recipesRules.perRecipe}
          onChange={(v) => updateRecipesRulesHours('perRecipe', v)}
          description="Hours per additional recipe"
        />
        <HourConfigField
          label="Custom Duplicate Rules"
          value={recipesRules.customDuplicateRules}
          onChange={(v) => updateRecipesRulesHours('customDuplicateRules', v)}
          description="Custom duplicate detection rules"
        />
        <HourConfigField
          label="Custom Blocklist Rules"
          value={recipesRules.customBlocklistRules}
          onChange={(v) => updateRecipesRulesHours('customBlocklistRules', v)}
          description="Custom blocklist rules"
        />
      </div>

      {/* Integration & Access */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Integration & Access</h4>
        <HourConfigField
          label="API Integration Setup"
          value={general.integrationApiSetup}
          onChange={(v) => updateGeneralHours('integrationApiSetup', v)}
          description="API integration configuration"
        />
        <HourConfigField
          label="Portal Integration Setup"
          value={general.integrationPortalSetup}
          onChange={(v) => updateGeneralHours('integrationPortalSetup', v)}
          description="Portal integration configuration"
        />
        <HourConfigField
          label="SSO Setup"
          value={general.ssoSetup}
          onChange={(v) => updateGeneralHours('ssoSetup', v)}
          description="Single Sign-On configuration"
        />
        <HourConfigField
          label="AI Features"
          value={general.aiFeatures}
          onChange={(v) => updateGeneralHours('aiFeatures', v)}
          description="AI feature configuration"
        />
      </div>

      {/* Custom Work */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Custom Work</h4>
        <HourConfigField
          label="Per Custom Work Item"
          value={general.perCustomWorkItem}
          onChange={(v) => updateGeneralHours('perCustomWorkItem', v)}
          description="Hours per custom work item in scope"
        />
      </div>

      {/* Testing & Training */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Testing & Training</h4>
        <HourConfigField
          label="Testing"
          value={general.testing}
          onChange={(v) => updateGeneralHours('testing', v)}
          description="QA and testing hours"
        />
        <HourConfigField
          label="Training"
          value={general.training}
          onChange={(v) => updateGeneralHours('training', v)}
          description="Customer training sessions"
        />
        <HourConfigField
          label="Documentation"
          value={general.documentation}
          onChange={(v) => updateGeneralHours('documentation', v)}
          description="Custom documentation"
        />
      </div>
    </div>
  )
}
